import { render, staticRenderFns } from "./Culture.vue?vue&type=template&id=19ef513e&scoped=true"
import script from "./Culture.vue?vue&type=script&lang=js"
export * from "./Culture.vue?vue&type=script&lang=js"
import style0 from "./Culture.vue?vue&type=style&index=0&id=19ef513e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19ef513e",
  null
  
)

export default component.exports